import styled from 'styled-components'

export const UserCard = styled.div`
   padding: 10px 20px;
`
